import { computed, toValue } from 'vue'

import { phoneNumberFormat } from '@/utils/phoneNumberFormat'
import type { PhoneNumberFormatOptions } from '@/utils/phoneNumberFormat'

import type { MaybeRefOrGetter } from 'vue'

export function usePhoneNumberFormat(
  options: MaybeRefOrGetter<PhoneNumberFormatOptions>,
) {
  return computed(() => phoneNumberFormat(toValue(options)))
}
